var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M15,56a7,7,0,1,1,7-7A7,7,0,0,1,15,56Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,15,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.47,59a5.51,5.51,0,0,1-5.5-5.5A20.53,20.53,0,0,0,11.46,32.95a5.5,5.5,0,1,1,0-11A31.55,31.55,0,0,1,43,53.46,5.51,5.51,0,0,1,37.47,59Zm-26-35a3.5,3.5,0,1,0,0,7A22.53,22.53,0,0,1,34,53.46a3.5,3.5,0,0,0,7,0A29.54,29.54,0,0,0,11.46,23.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,58.5a5.51,5.51,0,0,1-5.5-5.5A37.44,37.44,0,0,0,11,15.61a5.5,5.5,0,1,1,0-11A48.45,48.45,0,0,1,59.39,53,5.51,5.51,0,0,1,53.89,58.5ZM11,6.61a3.5,3.5,0,1,0,0,7A39.44,39.44,0,0,1,50.39,53a3.5,3.5,0,0,0,7,0A46.45,46.45,0,0,0,11,6.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.4c4da65c10f2f3e861e9fb6f8c3378b3.svg";
export { ForwardRef as ReactComponent };